export default {
  topText: {
    id: 'product_page_carousel_sticker_top_text',
    defaultMessage: 'Professionally',
  },
  bottomText: {
    id: 'product_page_carousel_sticker_bottom_text',
    defaultMessage: 'refurbished',
  },
}
